import { useState } from 'react';
import CommentParticipants from '@components/Message/CommentParticipants';
import s from '../UserWorkflowDetailCustomerView.module.scss';
import CollaboratorList from './ListModal';

type Props = {
  collaborators: Parameters<typeof CollaboratorList>[0]['collaborators'] & Parameters<typeof CommentParticipants>[0]['participants'];
  userWorkflow: { id: string };
  onChangeCollaborator: Parameters<typeof CollaboratorList>[0]['onChange'];
  // @todo - call with the added collaborator, or all collaborators with the added, so that UserWorkflowDetail doesn't need to refetch them all.
  myCollaborator: Parameters<typeof CollaboratorList>[0]['myCollaborator'];
  isUserProfileDetails?: boolean;
  avatarsOnly?: boolean;
};

const Collaborators: React.FC<Props> = ({
  collaborators,
  userWorkflow,
  myCollaborator,
  onChangeCollaborator,
  isUserProfileDetails,
  avatarsOnly,
}) => {
  const [isCollaboratorListModalOpen, setIsCollaboratorListModalOpen] = useState(false);

  return (
    <div className={s.collaborators} style={(isUserProfileDetails && { padding: 0, paddingBottom: 16 }) || undefined}>
      {isCollaboratorListModalOpen && (
        <CollaboratorList
          userWorkflow={userWorkflow}
          collaborators={collaborators}
          onClose={() => setIsCollaboratorListModalOpen(false)}
          onChange={onChangeCollaborator}
          myCollaborator={myCollaborator}
        />
      )}
      <div>
        <CommentParticipants showNames participants={collaborators} userLogoSize={22} noLabel maxLength={5} />
        {!avatarsOnly && (
          <button
            className={s['open-list-button']}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              setIsCollaboratorListModalOpen(true);
            }}
          >
            See all collaborators
          </button>
        )}
      </div>
    </div>
  );
};

export default Collaborators;
